import { DefinitionResponse } from 'src/paraphraser/models/api';
import { deleteDB, openDB } from 'idb';
import { IndexedDb } from 'config/constants';

class IndexDbStoreOld {
  private static instance: IndexDbStoreOld | null;

  dbDefinationPromise: any;

  dbReportPromise: any;

  constructor() {
    if (window.indexedDB) {
      this.dbDefinationPromise = openDB('defination-store', 1, {
        upgrade(db) {
          db.createObjectStore('definations');
        },
      });
      this.dbReportPromise = openDB('report-store', 1, {
        upgrade(db) {
          db.createObjectStore('reportedWords');
          db.createObjectStore('sentenceReported');
        },
      });
    }
  }

  static getInstance(): IndexDbStoreOld {
    if (!IndexDbStoreOld.instance) IndexDbStoreOld.instance = new IndexDbStoreOld();
    return IndexDbStoreOld.instance;
  }

  setDB = async (key: string, val: DefinitionResponse) => {
    try {
      (await this.dbDefinationPromise).put('definations', val, key);
    } catch (err) {
      // continue regardless of error
    }
  };

  setReportDB = async (key: string, val: string, storeName: string) => {
    try {
      (await this.dbReportPromise).put(storeName, val, key);
    } catch (err) {
      // continue regardless of error
    }
  };

  getDB = async (key: string): Promise<DefinitionResponse | null> => {
    try {
      return (await this.dbDefinationPromise).get('definations', key);
    } catch (err) {
      return null;
      // continue regardless of error
    }
  };

  getReportDB = async (key: string, storeName: string) => {
    try {
      return (await this.dbReportPromise).get(storeName, key);
    } catch (err) {
      return null;
      // continue regardless of error
    }
  };

  getAllReport = async (storeName: string) => {
    try {
      const data: any = await (await this.dbReportPromise).getAll(storeName);
      const key: any = await (await this.dbReportPromise).getAllKeys(storeName);

      const wholeData = key.map((eachKey: string, index: number) => ({
        key: eachKey,
        value: data[index],
      }));

      return { dataStoreName: storeName, data: wholeData };
    } catch (err) {
      return null;
      // continue regardless of error
    }
  };

  getAllDefinations = async (storeName: string) => {
    /*
      We are taking the whole key value pairs from the db collection
      and make a whole object with the collection name and return
    */

    try {
      const data: any = await (await this.dbDefinationPromise).getAll(storeName);
      const key: any = await (await this.dbDefinationPromise).getAllKeys(storeName);

      const wholeData = key.map((eachKey: string, index: number) => ({
        key: eachKey,
        value: data[index],
      }));

      return { dataStoreName: storeName, data: wholeData };
    } catch (err) {
      return null;
      // continue regardless of error
    }
  };

  deleteDatabse = async () => {
    deleteDB('defination-store');
    deleteDB('report-store');
    IndexDbStoreOld.instance = null;
  };
  // deleteReportDB = async (key: string, storeName: string) => {
  //   try {
  //     return (await this.dbReportPromise).delete(storeName, key);
  //   } catch (err) {
  //     return null;
  //     // continue regardless of error
  //   }
  // };
}
export default IndexDbStoreOld;
